import React from 'react';
import './style.scss';

export default ({ children, ...props}) => <div className='zt-form'>
    <form {...props}>
        {children}
    </form>
</div>